<template>
	<div class="button-slot">
		<a :href="urlProp" class="link">
			<svg v-if="iconProp == 'heart'" class="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16.7 15.3"><path fill="#e30613" d="M4.4 1.4c2.2 0 3.4 2.4 4 3.5.5-1 1.7-3.5 4-3.5a2.8 2.8 0 0 1 3 3c0 2.3-3.4 5.4-7 9-3.7-3.6-7-6.7-7-9.1a2.8 2.8 0 0 1 3-2.9Zm0-1.4A4.2 4.2 0 0 0 0 4.3c0 3.3 3.9 6.6 8.4 11 4.4-4.4 8.3-7.7 8.3-11A4.2 4.2 0 0 0 12.3 0a4.5 4.5 0 0 0-4 2.3 4.5 4.5 0 0 0-4-2.3Z"></path></svg>
			<svg v-if="iconProp == 'file'" class="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="#e30613" d="M15 2v5h5v15h-16v-20h11zm1-2h-14v24h20v-18l-6-6z"/></svg>
			{{ labelProp }}
		</a>
	</div> <!-- product__col -->
</template>

<script>

export default {
	props: ['urlProp', 'labelProp', 'iconProp'],
	data() {
		return {};	
	},
};
</script>

<style scoped>
	.button-slot {
		display: inline-block;
		margin: 0;
	}

	@media screen and (min-width: 470px) {
		.button-slot {
			width: auto;
		}
	}

	.link {
		text-decoration: none;
		display: inline-flex;
		align-content: center;
	}

	.icon {
		width: 20px;
		margin: 0 1rem 0 0;
	}
</style>
